import {Component, OnInit, AfterViewInit, TemplateRef, ViewChild} from '@angular/core';
import { Router } from '@angular/router';

import { ApiUrl } from '../custom-services/api-url/api-url';
import { ApiService } from '../custom-services/ApiService';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.css'],
    standalone: false
})
export class LandingPageComponent implements OnInit, AfterViewInit {

  year: number;
  /* Code refractor By adib
  sonaliBankePaymentPortalUrl: any; */
  eLedgerPortalUrl: any;
  gonovotePdfSrc = "assets/gonovote.pdf"

  employmentTypeTooltip: any = `<span class="btn-block well-sm" style="margin-left: 20px">Never trust not sanitized HTML!!!</span>`;
  modalRef: BsModalRef;
  modalRefConfirm: BsModalRef;
  maintenanceModalRef: BsModalRef;
  @ViewChild('maintenanceModal') maintenanceModal: TemplateRef<any>;
  // @ViewChild('confirmPopup', {static: true}) confirmPopup: TemplateRef<any>;

  constructor(private router: Router,
    private apiService: ApiService,

    private apiUrl: ApiUrl,
    private modalService: BsModalService) { }

  ngOnInit(): void {
    this.apiUrl.getUrl().subscribe(res => {
      this.eLedgerPortalUrl = res['eLedgerPortalUrl'].url;
    });
    this.year = new Date().getFullYear();
    // this.showConfirmPopUp(this.confirmPopup);
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.openMaintenanceModalIfNeeded(), 150);
  }

  private getMaintenanceModalEndDate(): Date {
    return new Date(new Date().getFullYear(), 6, 1, 0, 30, 0, 0);
  }

  private shouldShowMaintenanceModal(): boolean {
    return new Date() < this.getMaintenanceModalEndDate();
  }

  openMaintenanceModalIfNeeded(): void {
    if (!this.shouldShowMaintenanceModal() || !this.maintenanceModal) {
      return;
    }

    this.maintenanceModalRef = this.modalService.show(this.maintenanceModal, {
      class: 'modal-dialog-centered maintenance-modal-dialog modal-lg',
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: true
    });
  }

  closeMaintenanceModal(): void {
    this.maintenanceModalRef?.hide();
  }



  afterLoadComplete(event){
  }

  // showConfirmPopUp(templateId: TemplateRef<any>): void {
  //   this.modalRefConfirm = this.modalService.show(templateId, {class: 'modal-lg  modal-dialog modal-fade modal-dialog-centered'});
  // }

  goToEtin() {
    window.location.href = 'https://secure.incometax.gov.bd/TINHome';
  }

  goToEledger() {
    // window.location.href = this.eLedgerPortalUrl;
    this.router.navigate(["/eLedger"]);
  }

  goToEReturn() {
    //localStorage.clear();
    this.router.navigate(["/auth/sign-in"]);
  }

  onClickETaxPayment() {
    // window.location.href = this.sonaliBankePaymentPortalUrl;
    this.router.navigate(["/e-tax-payment"]);
  }

  onClickEReturn(event: MouseEvent, modal: TemplateRef<any>): void {
    event.preventDefault();
    event.stopPropagation();
    this.modalRef = this.modalService.show(modal,{class:'modal-lg modal-dialog-centered '})
  }

  navigateToEReturnSignIn(){
    this.modalRef.hide()
    this.router.navigate(["/auth/sign-in"])
  }

  navigateToEReturnSignUp(){
    this.modalRef.hide()
    this.router.navigate(["/auth/sign-up"])
  }
}
